import { ContactGeneralInfo, ContactShopsInfo, getStorePhones, getStoreShops } from "@/components/StoreContacts.jsx";
import { STORE_NAME } from "@/utils/constants.js";
import { useStoreInfo } from "@/store/StoreInfoContext.jsx";
import "./contact.css";

export default function ContactPage() {
    const { storeInfo, loading, error } = useStoreInfo();

    const hasGeneralInfo = getStorePhones(storeInfo).length > 0
        || !!storeInfo?.email
        || !!storeInfo?.facebookUrl;
    const hasShops = getStoreShops(storeInfo).length > 0;
    const useTwoColumns = hasGeneralInfo && hasShops;
    const hasAnyContact = hasGeneralInfo || hasShops;

    return (
        <main className="container contact-page">
            <h1>Contact</h1>
            <section className="card contact-card">
                <p className="contact-intro">
                    Une question sur nos produits ou votre commande ? Contactez {STORE_NAME}.
                </p>
                {loading && <p className="muted">Chargement des coordonnées...</p>}
                {!loading && error && <p className="error">{error}</p>}
                {!loading && !error && !hasAnyContact && (
                    <p className="muted">
                        Les coordonnées seront affichées ici dès qu&apos;elles seront configurées.
                    </p>
                )}
                {!loading && hasAnyContact && (
                    <div className={useTwoColumns ? "contact-layout" : "contact-layout contact-layout--single"}>
                        <div className="contact-layout-column contact-layout-column--general">
                            <ContactGeneralInfo storeInfo={storeInfo} />
                        </div>
                        <div className="contact-layout-column contact-layout-column--shops">
                            <ContactShopsInfo storeInfo={storeInfo} />
                        </div>
                    </div>
                )}
            </section>
        </main>
    );
}
